import React, {useState} from 'react'
import { MiFooter } from '../../components/footer/MiFooter'
import { ContentBodyCategoriasServicios } from '../../components/CategoriasServicios/ContentBodyCategoriasServicios'
import './CategoriasServicios.css'
import { useContext } from 'react'
import { UsuarioContext } from '../../contexts/UsuarioContext'
import HeaderHome from '../../components/headerHome/HeaderHome'

export const CategoriasServicios = () => {
    const [MenuLateralAux, setMenuLateralAux] = useState();

    const chageMenuLateralAux = () => {
        setMenuLateralAux(!MenuLateralAux)
    }
    return (
        <>
            <div className='CategoriasServicios'  >
                <div className='headerCategoriasServicios'>
                    <HeaderHome
                        chageMenuLateralAux={chageMenuLateralAux}
                    />
                </div>
                <div className="bodyCategoriasServicios">
                    <ContentBodyCategoriasServicios
                        MenuLateralAux={MenuLateralAux}
                        chageMenuLateralAux={chageMenuLateralAux}
                    />
                </div>
                <div className='footerReservarServicio'>
                    <MiFooter />
                </div>
            </div>
        </>
    )
}
